import React from "react";
import { DropdownButton, Dropdown } from "react-bootstrap";
import cropr from "../utils/cropr";

function setLanguage(lang: string, url = "/cropr/settings/language/") {
  // who knows a better method?
  var name = "csrftoken",
    cookieValue = null;
  if (document.cookie) {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = jQuery.trim(cookies[i]);
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  console.log("submitting");
  $(
    `<form style="display:none;" action="${url}" method="post">
     <input type="text" name="csrfmiddlewaretoken" value="${cookieValue}"/>
     <input name="language" type="text" value="${lang}"/>
     <input name="next" type="text" value="${encodeURI(window.location.href)}"/>
     </form>`
  )
    .appendTo($("body"))
    .submit();
}

const LanguageToFlagCode: { [index: string]: string } = {
  en: "gb",
  ja: "jp",
};

const Flag = ({ languageCode, language }: { languageCode: string; language?: string }) => (
  <>
    <i className={`flag-${LanguageToFlagCode[languageCode] || languageCode}`} />
    {language && ` ${language}`}
  </>
);

const LanguageSwitch = ({ variant = "success", text = true }) => {
  const c = cropr.l10n && cropr.l10n.languageCode ? cropr.l10n.languageCode : "nl";
  // @ts-ignore
  const languages: [string, string][] = window.LANGUAGES || [
    ["nl", "Nederlands"],
    ["en", "English"],
    ["fr", "Français"],
    ["de", "Deutsch"],
    ["ja", "日本語"],
  ];
  const current = languages.find(([code, language]) => code === c) || [c, c];
  return (
    <DropdownButton
      variant={variant}
      title={<Flag languageCode={current[0]} language={text ? current[1] : ""} />}
    >
      {languages.map(([code, language]) => (
        <Dropdown.Item
          key={code}
          onClick={() => setLanguage(code)}
          children={<Flag languageCode={code} language={language} />}
        />
      ))}
    </DropdownButton>
  );
};
export default LanguageSwitch;
